<!-- Top loader between routes on navigation -->
<app-slim-loader></app-slim-loader>

<!-- Main app route component -->
<div class="animated fadeIn h-100">
    <router-outlet></router-outlet>
</div>

<!-- Gable AI drawer — only mount on authenticated routes so its service
     chain (GableDrawerService → GableService) never initializes on
     public pages like /sign-up or /auth/password/request-reset-email
     (those break otherwise — see PR #2909 / SD-XXXX for the diagnosis). -->
<app-gable-drawer-host *ngIf="isLoggedIn"></app-gable-drawer-host>

<!-- "Report a bug" drawer — mounted beside the Gable drawer host, behind the
     same authenticated *ngIf. Self-gates internally (super user + the global
     BUG_REPORTER_ENABLED kill switch) via the report-bug button that toggles it. -->
<app-report-bug-drawer-host *ngIf="isLoggedIn"></app-report-bug-drawer-host>
